import React from 'react';
import DriverApplicationForm from '../components/driver/DriverApplicationForm';

const ApplyDriverPage: React.FC = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      <DriverApplicationForm />
    </div>
  );
};

export default ApplyDriverPage;
